import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { MaintenanceCard, PortfolioAlertCard, FinancialCard, OccupancyCard } from "@/components/glimpses/Glimpses";

export const GlimpsesSection = () => (
  <section className="section bg-white" data-testid="glimpses-section">
    <div className="container-x grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-5">
        <SectionHead eyebrow="Inside ANFORD" title="Real software. Built for how properties are run." copy="A glimpse of the interface your team will work in every day. The full platform is best seen in a demo." />
      </div>
      <Reveal delay={0.1} className="lg:col-span-7">
        <div className="relative mx-auto grid max-w-lg grid-cols-2 gap-4 sm:gap-5" data-testid="glimpse-grid">
          <MaintenanceCard className="sm:translate-y-6" />
          <PortfolioAlertCard />
          <FinancialCard className="hidden sm:block sm:translate-y-6" />
          <OccupancyCard className="col-span-2 sm:col-span-1" />
        </div>
      </Reveal>
    </div>
  </section>
);
